import {
  LAYERD_SINGLE_DATETIME_PICKER_CLASS,
  PICKER_BODY_MIN_HEIGHT,
  PICKER_PRIMARY,
  PICKER_PRIMARY_HOVER,
  PICKER_PRIMARY_SOFT,
} from "./constants";

/** Wrapper around hidden RangePicker in GreenTimeRangePicker — unchanged behaviour. */
export const layerdRangePickerWrapperSx = {
  position: "relative",
  "&.layerd-range-picker--instant .react-minimal-datetime-range": {
    transition: "none !important",
    opacity: "1 !important",
    transform: "translateY(0) perspective(600px) rotateX(0) !important",
    visibility: "visible !important",
    pointerEvents: "auto !important",
  },
  "& .react-minimal-datetime-range__range": {
    position: "relative",
  },
  // Library keeps the closed panel at opacity:0 (still in layout / hit-testing).
  // Without this, the invisible calendar can sit over the filter bar and steal clicks.
  "& .react-minimal-datetime-range:not(.visible)": {
    pointerEvents: "none",
    visibility: "hidden",
  },
  "& .react-minimal-datetime-range.visible": {
    zIndex: 1200,
    pointerEvents: "auto",
    visibility: "visible",
    boxShadow: "0 8px 24px rgba(17, 17, 17, 0.12)",
    borderRadius: "8px",
    border: "1px solid #E5E7EB",
    minWidth: "fit-content",
  },
  "& .react-minimal-datetime-date-piker": {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "flex-start",
    gap: "16px",
  },
  "& .react-minimal-datetime-range__calendar": {
    marginBottom: "0 !important",
    flexShrink: 0,
  },
  "& .react-minimal-datetime-range-calendar--range": {
    flexShrink: 0,
  },
  "& .layerd-range-picker__range-error": {
    marginTop: "10px",
    padding: "8px 10px",
    borderRadius: "6px",
    border: "1px solid #D00416",
    backgroundColor: "rgba(251,55,72,0.08)",
    color: "#D00416",
    fontFamily: "rubik, sans-serif",
    fontSize: "13px",
    lineHeight: "18px",
    minHeight: "34px",
    boxSizing: "border-box",
  },
};

export const layerdPickerPopoverPaperSx = {
  mt: 0.5,
  overflow: "visible",
  boxShadow: "none",
  bgcolor: "transparent",
};

/**
 * Popover panel for single datetime — CalendarPicker + time columns + Confirm.
 * Matches GreenTimeRangePicker layout and tokens.
 */
export const layerdSingleDateTimePickerSx = {
  position: "relative",
  minWidth: 300,
  p: "14px 16px 12px",
  borderRadius: "8px",
  border: "1px solid #E5E7EB",
  boxShadow: "0 8px 24px rgba(17, 17, 17, 0.12)",
  backgroundColor: "#fff",
  fontFamily: "rubik, sans-serif",
  fontSize: "13px",
  "--layerd-picker-primary": PICKER_PRIMARY,
  "--layerd-picker-primary-hover": PICKER_PRIMARY_HOVER,
  "--layerd-picker-primary-soft": PICKER_PRIMARY_SOFT,
  "& .react-minimal-datetime-date-piker": {
    marginBottom: 0,
    minHeight: PICKER_BODY_MIN_HEIGHT,
  },
  "& > .react-minimal-datetime-range.visible": {
    padding: 0,
    border: "none",
    boxShadow: "none",
    backgroundColor: "transparent",
    opacity: 1,
    transform: "none",
  },
  "& .react-minimal-datetime-range.visible": {
    padding: 0,
    border: "none",
    boxShadow: "none",
    backgroundColor: "transparent",
    opacity: 1,
    transform: "none",
  },
  "& .react-minimal-datetime-range__calendar": {
    marginBottom: "0 !important",
    paddingBottom: 0,
  },
  "& .react-minimal-datetime-range__calendar .react-minimal-datetime-range": {
    padding: 0,
    border: "none",
    boxShadow: "none",
    backgroundColor: "transparent",
    opacity: 1,
    transform: "none",
  },
  "& .react-minimal-datetime-range-calendar--range": {
    paddingBottom: 0,
    marginBottom: 0,
  },
  "& .react-minimal-datetime-range-calendar__content .react-minimal-datetime-range-calendar__table": {
    marginTop: "8px !important",
  },
  "& .react-minimal-datetime-range__close": {
    display: "none !important",
  },
  "& .react-minimal-datetime-range-calendar__default-day": {
    display: "none !important",
  },
  "& .react-minimal-datetime-range-calendar__today": {
    display: "none !important",
  },
  "& .react-minimal-datetime-range-calendar__button": {
    display: "none !important",
  },
  "& .react-minimal-datetime-range-check": {
    display: "none !important",
  },
  "& .layerd-single-datetime-picker__time": {
    position: "relative !important",
    top: "auto !important",
    right: "auto !important",
    bottom: "auto !important",
    left: "auto !important",
    marginTop: "0 !important",
    minHeight: PICKER_BODY_MIN_HEIGHT,
    height: PICKER_BODY_MIN_HEIGHT,
    display: "flex",
    flexDirection: "column",
  },
  "& .layerd-single-datetime-picker__time-columns": {
    flex: 1,
    minHeight: PICKER_BODY_MIN_HEIGHT,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    minWidth: 240,
    textAlign: "center",
  },
  "& .layerd-single-datetime-picker__time-date": {
    flexShrink: 0,
  },
  "& .layerd-single-datetime-picker__time-scrolls": {
    flex: 1,
    minHeight: 0,
    display: "flex",
    alignItems: "stretch",
  },
  "& .layerd-single-datetime-picker__time-scrolls .react-minimal-datetime-range__time-select-options-wrapper":
    {
      flex: "1 1 50%",
      width: "50% !important",
      height: "100% !important",
      maxHeight: "none",
      overflowY: "auto",
    },
  "& .react-minimal-datetime-range__time-select-wrapper--single": {
    minWidth: 240,
    textAlign: "center",
  },
  "& .react-minimal-datetime-range__date": {
    marginBottom: "6px !important",
  },
  "& .react-minimal-datetime-range__time-select-option": {
    padding: "4px 6px !important",
    lineHeight: "1.2",
  },
  "& .layerd-single-datetime-picker__footer": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    marginTop: "10px",
    minHeight: 32,
  },
  "& .layerd-single-datetime-picker__error": {
    marginTop: "10px",
    padding: "8px 10px",
    borderRadius: "6px",
    border: "1px solid #D00416",
    backgroundColor: "rgba(251,55,72,0.08)",
    color: "#D00416",
    fontSize: "13px",
    lineHeight: "18px",
  },
  "& .layerd-single-datetime-picker__footer-spacer": {
    flex: "0 0 auto",
  },
  "& .layerd-single-datetime-picker__footer-actions": {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "8px",
    marginLeft: "auto",
  },
  "& .layerd-single-datetime-picker__today, & .layerd-single-datetime-picker__footer-actions .react-minimal-datetime-range__button":
    {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 32,
      height: 32,
      padding: "0 12px",
      margin: 0,
      fontSize: 13,
      lineHeight: 1,
      borderRadius: "3px",
      cursor: "pointer",
      boxSizing: "border-box",
      fontFamily: "rubik, sans-serif",
      whiteSpace: "nowrap",
    },
  "& .layerd-single-datetime-picker__today": {
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    color: "#868e96",
  },
  "& .layerd-single-datetime-picker__today:hover": {
    backgroundColor: PICKER_PRIMARY,
    borderColor: PICKER_PRIMARY,
    color: "#fff",
  },
  "& .react-minimal-datetime-range-calendar__table-cel.active": {
    backgroundColor: `${PICKER_PRIMARY} !important`,
    color: "#fff !important",
  },
  "& .react-minimal-datetime-range-calendar__table-cel.react-minimal-datetime-range-calendar__date-item:not(.disabled):hover":
    {
      backgroundColor: `${PICKER_PRIMARY} !important`,
      color: "#fff !important",
    },
  // Library `.today` can be UTC-skewed; local today is marked via `markedDates`.
  "& .react-minimal-datetime-range-calendar__table-cel.today": {
    color: "inherit",
  },
  "& .react-minimal-datetime-range-calendar__table-cel.marked": {
    color: `${PICKER_PRIMARY} !important`,
    position: "relative",
  },
  "& .react-minimal-datetime-range-calendar__table-cel.marked:after": {
    backgroundColor: `${PICKER_PRIMARY} !important`,
  },
  "& .react-minimal-datetime-range-calendar__table-cel.active.marked": {
    color: "#fff !important",
  },
  "& .react-minimal-datetime-range-calendar__table-cel.active.marked:after": {
    backgroundColor: "#fff !important",
  },
  "& .react-minimal-datetime-range__time-select-option:hover": {
    backgroundColor: PICKER_PRIMARY_SOFT,
  },
  "& .react-minimal-datetime-range__time-select-option.active": {
    backgroundColor: `${PICKER_PRIMARY} !important`,
    color: "#fff !important",
  },
  "& .react-minimal-datetime-range-calendar__button:hover": {
    backgroundColor: `${PICKER_PRIMARY} !important`,
    borderColor: `${PICKER_PRIMARY} !important`,
    color: "#fff !important",
  },
  "& .react-minimal-datetime-range__button--type": {
    color: PICKER_PRIMARY,
    border: `1px solid ${PICKER_PRIMARY}`,
    backgroundColor: "#fff",
  },
  "& .react-minimal-datetime-range__button--type.disabled": {
    color: "#adb5bd",
    borderColor: "#ced4da",
    cursor: "not-allowed",
  },
  "& .react-minimal-datetime-range__button--confirm.disabled": {
    backgroundColor: "#f1f3f5 !important",
    border: "1px solid #ced4da !important",
    color: "#adb5bd !important",
    cursor: "not-allowed",
  },
  "& .react-minimal-datetime-range__button--confirm": {
    backgroundColor: `${PICKER_PRIMARY} !important`,
    border: `1px solid ${PICKER_PRIMARY} !important`,
    color: "#fff !important",
  },
};

export { LAYERD_SINGLE_DATETIME_PICKER_CLASS };
